export default "__VITE_ASSET__4cd9fa7b__"